// extracted by mini-css-extract-plugin
export default {"tableWrapper":"styles_tableWrapper__bWgQy","loadingContainer":"styles_loadingContainer__ql5Zt"};